import { useQuery } from '@tanstack/react-query';
import { apiFetch } from '../api/client';

export type SystemState = 'running' | 'warning' | 'error' | 'idle';

export interface SystemComponent {
  name: string;
  detail: string;
  state: SystemState;
  region: string;
}

export function useSystemComponents() {
  return useQuery<ReadonlyArray<SystemComponent>>({
    queryKey: ['system', 'components'],
    queryFn: async ({ signal }) => {
      const resp = await apiFetch<unknown>('/monitor/system-components', {
        method: 'POST',
        body: {},
        signal,
      });
      if (Array.isArray(resp)) return resp as ReadonlyArray<SystemComponent>;
      const items = (resp as { items?: ReadonlyArray<SystemComponent> })?.items;
      return items ?? [];
    },
  });
}
